import n from "react";
import o from "prop-types";
import C from "classnames";
import { mintelRed400 as p } from "mintel-tokens";
import { u as I } from "./ThemeProvider--i7ESlT5.es.js";
import { T as b } from "./index-BB-Wk85r.es.js";
import { I as y } from "./Icon-ByeAHRM4.es.js";
import { I as $ } from "./InputError-BEWrKIXS.es.js";
import { L as h } from "./utils-Ci4OZEP4.es.js";
import './CheckboxGroup.css';const v = "CheckboxGroup-module__checkboxGroup___1obq3", E = "CheckboxGroup-module__checkbox___mzr-T", f = {
  checkboxGroup: v,
  checkbox: E
}, w = "#666", N = "#ccc", q = "#fff", B = "#026fd9", S = "#c88c00", L = "#458415", z = "#ac2f96", G = "#385442", T = "#4d4e8c", D = "Checkbox-default-module__container___q23gz", O = "Checkbox-default-module__error___n-fZf", R = "Checkbox-default-module__checkbox___t-GoR", K = "Checkbox-default-module__selected___BgolO", P = "Checkbox-default-module__label___lNqhn", V = "Checkbox-default-module__blue___I0sgN", X = "Checkbox-default-module__gold___78Dnm", j = "Checkbox-default-module__green___o2QUK", F = "Checkbox-default-module__purple___OIumH", H = "Checkbox-default-module__mint___rqsxb", M = "Checkbox-default-module__lavender___M-qV4", k = {
  border: w,
  disabled: N,
  white: q,
  blueIcon: B,
  goldIcon: S,
  greenIcon: L,
  purpleIcon: z,
  mintIcon: G,
  lavenderIcon: T,
  container: D,
  error: O,
  checkbox: R,
  selected: K,
  label: P,
  blue: V,
  gold: X,
  green: j,
  purple: F,
  mint: H,
  lavender: M
}, Q = "#666", U = "#ccc", A = "#fff", Z = "#008eff", J = "#ffa343", W = "#00857a", Y = "#ff0076", ee = "#d500f9", oe = "Checkbox-compere-module__container___52pBO", le = "Checkbox-compere-module__error___pFT2L", ce = "Checkbox-compere-module__checkbox___UjQ3l", ne = "Checkbox-compere-module__selected___BFwEt", re = "Checkbox-compere-module__label___bDqqq", te = "Checkbox-compere-module__blue___vldX7", ae = "Checkbox-compere-module__gold___MNS6G", de = "Checkbox-compere-module__green___i-8B-", se = "Checkbox-compere-module__pink___qjS1q", ie = "Checkbox-compere-module__purple___XHVyX", be = {
  border: Q,
  disabled: U,
  white: A,
  blueIcon: Z,
  "deep-purpleIcon": "#8e3eff",
  goldIcon: J,
  greenIcon: W,
  pinkIcon: Y,
  purpleIcon: ee,
  container: oe,
  error: le,
  checkbox: ce,
  selected: ne,
  label: re,
  blue: te,
  "deep-purple": "Checkbox-compere-module__deep-purple___-SXdB",
  gold: ae,
  green: de,
  pink: se,
  purple: ie
}, _e = {
  default: k,
  compere: be
}, _ = {
  default: ["blue", "gold", "green", "purple", "mint", "lavender"],
  compere: ["blue", "deep-purple", "gold", "green", "pink", "purple"]
}, ue = (e) => _e[e] || k, me = (e) => _[e] || _.default, he = (e, r) => r.includes(e) ? e : "green", fe = (e) => b[e] || b.Body2, ke = (e, r) => {
  let l;
  return e === !0 ? l = "checkbox_checked" : e === "mixed" ? l = "checkbox_mixed" : r && (l = "checkbox_unchecked"), l;
}, xe = (e, r, l, c, a, d) => {
  let t;
  return r ? t = a.disabled : [!0, "mixed"].includes(e) ? t = a[`${d}Icon`] : c ? t = p : l && (t = a.border), t;
}, u = n.forwardRef((e, r) => {
  const l = I(), c = ue(l), a = me(l), d = he(e.color, a), t = fe(e.labelVariant), i = xe(
    e.checked,
    e.disabled,
    e.border,
    e.error,
    c,
    d
  ), s = ke(e.checked, e.border), g = e.error && !e.checked ? c.error : c[d];
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      "aria-checked": e.checked,
      "aria-disabled": e.disabled,
      "aria-labelledby": e.label && e.id ? `${e.id}-label` : e.ariaLabelledBy,
      className: C(c.container, g, {
        [c.selected]: e.checked !== !1
      }),
      id: e.id,
      onClick: e.disabled ? null : e.onChange,
      onKeyPress: e.disabled ? () => {
      } : (m) => {
        [" ", "Spacebar"].includes(m.key) && (m.preventDefault(), e.onChange());
      },
      onKeyDown: e.onKeyDown,
      tabIndex: e.disabled ? -1 : e.tabIndex,
      ref: r,
      role: "checkbox"
    },
    /* @__PURE__ */ n.createElement(
      "div",
      {
        className: c.checkbox,
        style: {
          width: `${e.size}px`,
          height: `${e.size}px`,
          fontSize: `${e.size}px`
          // req to make box-shadow size relative
        }
      },
      s && /* @__PURE__ */ n.createElement(
        y,
        {
          color: i,
          alt_color: c.white,
          name: s,
          size: e.size
        }
      )
    ),
    e.label && /* @__PURE__ */ n.createElement(
      "label",
      {
        className: c.label,
        id: e.id ? `${e.id}-label` : void 0,
        htmlFor: e.id
      },
      /* @__PURE__ */ n.createElement(
        t,
        {
          color: e.labelColor,
          theme: l,
          responsive: !0
        },
        e.label
      )
    )
  );
});
u.displayName = "Checkbox";
u.propTypes = {
  /** Maps to the `aria-checked` value of the div with role="checkbox" */
  checked: o.oneOf([!0, !1, "mixed"]).isRequired,
  /** The color of the chip. 'deep-purple' and 'pink' are Compere theme only, 'lavender' and 'mint' are default theme only.
   * If an invalid color/theme combination is provided, defaults to 'green' */
  color: o.oneOf([..._.compere, ..._.default]),
  /** Whether or not the checkbox is disabled */
  disabled: o.bool,
  /** id for the div with role="checkbox".
   * If both this and label are specified, the aria-labelledby prop will be populated with the id of the label
   * on the div with role="checkbox". */
  id: o.string,
  /** The input checkbox callback, called with the click/keypress event */
  onChange: o.func,
  /** The width and height of the checkbox in pixels. */
  size: o.number,
  /** The checkbox border will be displayed when this is true.
   * Note that the checkbox will not be visible at all in its unchecked state when this prop is false,
   * so there should be another way to toggle the state of the checkbox than with the `onChange` prop in this case. */
  border: o.bool,
  /** onKeyDown event handler passed to the interactive div of the checkbox, separate from the onChange which gets triggered on Spacebar  */
  onKeyDown: o.func,
  /** Optional text color for the textbox label. If none give, default text color will be used.  */
  labelColor: o.string,
  /** The MRUI Text variant to be used by the label, e.g. "Body2" or "Heading1 */
  labelVariant: o.oneOf(Object.keys(b)),
  /** The tabIndex of the div with role="checkbox". Exposed so it may be set to -1 when a roving tabIndex is being used.  */
  tabIndex: o.number,
  /** Text of the checkbox's label */
  label: o.string,
  /** If true, checkbox will have red error style */
  error: o.bool,
  /** HTML id of alternate label component */
  ariaLabelledBy: o.string
};
u.defaultProps = {
  border: !0,
  color: "green",
  disabled: !1,
  id: void 0,
  onChange: () => null,
  onKeyDown: void 0,
  size: 20,
  labelColor: void 0,
  labelVariant: "Heading5",
  tabIndex: 0,
  label: null,
  error: !1,
  ariaLabelledBy: void 0
};
const x = ({ id: e, children: r, error: l, label: c, ariaLabelledBy: a }) => {
  const d = l ? `${e}-error-message` : null, t = n.Children.toArray(r), i = `label-for-${e}`;
  return /* @__PURE__ */ n.createElement("div", null, c && /* @__PURE__ */ n.createElement(b.Body, { tagName: "label", id: i, responsive: !0 }, c), /* @__PURE__ */ n.createElement(
    "fieldset",
    {
      className: f.checkboxGroup,
      "aria-labelledby": a || i,
      "aria-describedby": d,
      "aria-invalid": !!l,
      id: e
    },
    t.map((s) => /* @__PURE__ */ n.createElement(
      "div",
      {
        key: s.props.label || s.props.ariaLabelledBy,
        className: f.checkbox
      },
      /* @__PURE__ */ n.createElement(u, { ...s.props, error: !!l })
    ))
  ), l && /* @__PURE__ */ n.createElement($, { id: d }, l));
};
x.propTypes = {
  /** Unique html id */
  id: o.string.isRequired,
  /** Checkbox components */
  children: o.node.isRequired,
  /** text to be displayed in an error message */
  error: o.string,
  /** text to be displayed for the label
   *
   * required if `ariaLabelledBy` is not defined
   */
  label: h,
  /** html id of alternate label
   *
   * required if `label` is not defined
   */
  ariaLabelledBy: h
};
x.defaultProps = {
  error: null,
  label: null,
  ariaLabelledBy: null
};
export {
  u as C,
  x as a
};
